// Step de Confirmação do onboarding
import { Button } from '../common/Button';
import { Card } from '../common/Card';

interface ConfirmationStepProps {
  companyData: {
    razaoSocial: string;
    nomeFantasia: string;
    cnpj: string;
    inscricaoEstadual: string;
    email: string;
    telefone: string;
  };
  addressData: {
    cep: string;
    logradouro: string;
    numero: string;
    complemento: string;
    bairro: string;
    cidade: string;
    estado: string;
  };
  onNext: () => void;
  onBack: () => void;
}

export function ConfirmationStep({ companyData, addressData, onNext, onBack }: ConfirmationStepProps) {
  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
          Confirmação dos Dados
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Revise todas as informações antes de finalizar o cadastro
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Dados da Empresa */}
        <Card>
          <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 pb-3 border-b border-gray-200 dark:border-gray-700">
            Dados da Empresa
          </h4>
          <div className="space-y-3 text-sm">
            <div>
              <p className="text-gray-500 dark:text-gray-400">Razão Social</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">{companyData.razaoSocial}</p>
            </div>
            <div>
              <p className="text-gray-500 dark:text-gray-400">Nome Fantasia</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">{companyData.nomeFantasia}</p>
            </div>
            <div>
              <p className="text-gray-500 dark:text-gray-400">CNPJ</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">{companyData.cnpj}</p>
            </div>
            {companyData.inscricaoEstadual && (
              <div>
                <p className="text-gray-500 dark:text-gray-400">Inscrição Estadual</p>
                <p className="font-medium text-gray-900 dark:text-gray-100">{companyData.inscricaoEstadual}</p>
              </div>
            )}
            <div>
              <p className="text-gray-500 dark:text-gray-400">Email</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">{companyData.email}</p>
            </div>
            <div>
              <p className="text-gray-500 dark:text-gray-400">Telefone</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">{companyData.telefone}</p>
            </div>
          </div>
        </Card>

        {/* Endereço */}
        <Card>
          <h4 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 pb-3 border-b border-gray-200 dark:border-gray-700">
            Endereço
          </h4>
          <div className="space-y-3 text-sm">
            <div>
              <p className="text-gray-500 dark:text-gray-400">CEP</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">{addressData.cep}</p>
            </div>
            <div>
              <p className="text-gray-500 dark:text-gray-400">Logradouro</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">{addressData.logradouro}</p>
            </div>
            <div>
              <p className="text-gray-500 dark:text-gray-400">Número</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">{addressData.numero}</p>
            </div>
            {addressData.complemento && (
              <div>
                <p className="text-gray-500 dark:text-gray-400">Complemento</p>
                <p className="font-medium text-gray-900 dark:text-gray-100">{addressData.complemento}</p>
              </div>
            )}
            <div>
              <p className="text-gray-500 dark:text-gray-400">Bairro</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">{addressData.bairro}</p>
            </div>
            <div>
              <p className="text-gray-500 dark:text-gray-400">Cidade / Estado</p>
              <p className="font-medium text-gray-900 dark:text-gray-100">
                {addressData.cidade} / {addressData.estado}
              </p>
            </div>
          </div>
        </Card>
      </div>

      <div className="flex justify-between pt-4 border-t border-gray-200 dark:border-gray-700">
        <Button variant="secondary" onClick={onBack}>
          Voltar
        </Button>
        <Button variant="primary" onClick={onNext} size="lg">
          Finalizar Cadastro
        </Button>
      </div>
    </div>
  );
}
